import { Inject, Injectable, OnDestroy, PLATFORM_ID } from '@angular/core';
import { Subject, switchMap, takeUntil, withLatestFrom } from 'rxjs';

import { AuthConfig, AuthConfigService, ConfigInitializerService, LanguageService, OAuthLibWrapperService, WindowRef } from '@spartacus/core';

import { AuthenticationConfigInitializer } from '../config/initializers/authentication-config.initializer';
import { ConfigurationService } from './configuration.service';
import { CustomOAuthService } from './custom-o-auth.service';
import { BaseStoreService } from './base-store.service';

@Injectable({
  providedIn: 'root'
})
export class CustomOAuthLibWrapperService extends OAuthLibWrapperService implements OnDestroy {
  private readonly destroy$: Subject<void> = new Subject();

  constructor(
    protected oAuthService: CustomOAuthService,
    protected authConfigService: AuthConfigService,
    @Inject(PLATFORM_ID) protected platformId: any,
    protected winRef: WindowRef,
    protected configInitializerService: ConfigInitializerService,
    protected languageService: LanguageService,
    protected baseStoreService: BaseStoreService,
    protected authConfig: AuthConfig,
    protected configService: ConfigurationService
  ) {
    super(oAuthService, authConfigService, platformId, winRef);
    this.initialize();
  }

  async getLoginUrl(): Promise<string> {
    return this.oAuthService.createLoginUrl();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected initialize(): void {
    this.configInitializerService
      ?.getStable('authentication')
      .pipe(
        switchMap(() => this.languageService.getActive()),
        withLatestFrom(this.baseStoreService.getBaseStore(), this.configService.getConfig()),
        takeUntil(this.destroy$)
      )
      .subscribe(([language, baseStore, config]) => {
        this.authConfig.authentication.loginUrl = AuthenticationConfigInitializer.getLoginUrl(
          baseStore,
          config,
          language
        );
        super.initialize();
      });
  }
}
